// extracted by mini-css-extract-plugin
module.exports = {"spinner":"style_spinner__1V7TM","small":"style_small__3IQ99","smaller":"style_smaller__cnPnQ"};